import React, { useState } from "react";

import { Form } from "@sainsburys-tech/luna-form";
import { BLACK_BOX_ELEMENT_ID, reportError } from "@jsainsburyplc/id-ui-common";

import { LOGIN_AFTER_WEB_AUTH_REGISTRATION_FORM_ID } from "constants/webAuthn";
import { CHALLENGE } from "constants/login";
import { getLoginLink } from "utils/urls";
import useCookies from "hooks/useCookies";
import { isIovationEnabled } from "utils/env";

import WebAuthnRegistration from "components/WebAuthnRegistration";
import WebAuthnRegistrationSuccess from "components/WebAuthnRegistrationSuccess";
import PageFormat from "components/PageFormat";

const getAndAssignBlackBoxToken = async (form) => {
  try {
    const bb = window.IGLOO.getBlackbox();
    if (bb && bb.finished) {
      form.elements[BLACK_BOX_ELEMENT_ID].value = bb.blackbox;
    } else {
      reportError("AutoLogin - the blackbox is not present!");
    }
  } catch (e) {
    reportError(
      `AutoLogin - error occurred during getAndAssignBlackBoxToken: ${e}`
    );
  }
};

const WebAuthnRegistrationPage = () => {
  const [isRegistered, setIsRegistered] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(undefined);

  const { loginChallenge } = useCookies();

  const isIovationEnabledEnv = isIovationEnabled();

  const onSubmit = async (e) => {
    e && e.preventDefault();
    const form = document.getElementById(
      LOGIN_AFTER_WEB_AUTH_REGISTRATION_FORM_ID
    );
    try {
      isIovationEnabledEnv && (await getAndAssignBlackBoxToken(form));
      setIsSubmitting(true);
      form.submit();
    } catch (error) {
      console.log(error);
      form.submit();
    }
  };

  return (
    <PageFormat>
      <Form
        method="post"
        onSubmit={onSubmit}
        action={getLoginLink()}
        id={LOGIN_AFTER_WEB_AUTH_REGISTRATION_FORM_ID}
      >
        <input
          type="hidden"
          name="from_webauthn_registration"
          defaultValue="1"
        />
        <input type="hidden" name={CHALLENGE} defaultValue={loginChallenge} />
        {!isRegistered && (
          <WebAuthnRegistration
            handleLogin={onSubmit}
            setIsRegistered={setIsRegistered}
          />
        )}
        {isRegistered && (
          <WebAuthnRegistrationSuccess
            handleLogin={onSubmit}
            isSubmitting={isSubmitting}
          />
        )}
      </Form>
    </PageFormat>
  );
};

export default WebAuthnRegistrationPage;
